/**
 * A constructor for a injectable.
 *
 * Declared for typing static `INJECTION_TOKEN`
 *
 * @internal
 */
export type InjectableConstructor<T = any> = {
  INJECTABLE_TOKEN: symbol;
  new (...args: any[]): T;
};

export type Disposable = {
  dispose(): void;
};

export const INJECTION_TOKEN = Symbol.for('Injections');
export interface Injectable extends Partial<Disposable> {}
